import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GroupForm } from "./GroupForm";

// Simulate fetch group by id (replace with real backend call)
const fetchGroupById = async (id) => {
  // For demo, return fake group data
  return {
    id,
    name: "Marketing Team",
    userIds: [1, 3, 5], // user ids in this group
  };
};

export function EditGroups() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGroupById(id)
      .then((data) => {
        setGroup(data);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleUpdate = (groupData) => {
    console.log("Updating group:", groupData);
    // Send update to backend here
    navigate("/groups");
  };

  if (loading) return <p className="text-center mt-8 text-gray-600">Loading group...</p>;

  return (
    <GroupForm
      initialGroup={group}
      onSubmit={handleUpdate}
      onCancel={() => navigate("/groups")}
    />
  );
}
